var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckbox = function SvgCheckbox(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9E2",
    d: "M11.889 1H4.11A3.11 3.11 0 0 0 1 4.111v7.778A3.11 3.11 0 0 0 4.111 15h7.778A3.11 3.11 0 0 0 15 11.889V4.11A3.11 3.11 0 0 0 11.889 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B1B2D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m5.667 8 1.75 1.556 2.916-3.11"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckbox);
export { ForwardRef as ReactComponent };